import { BooleanOptionsValue } from 'basics/enums/maya.enums';
import { SelectOption } from 'basics/options/options.types';

const booleanOptions: SelectOption[] = [
  { id: BooleanOptionsValue.true, label: BooleanOptionsValue.true },
  { id: BooleanOptionsValue.false, label: BooleanOptionsValue.false },
];

export default booleanOptions;
